import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CUIText } from '@dotcom/crown-ui';
import styles from '../preview.module.scss';

type PreviewGenerationErrorProps = {
  onRetry: () => void;
};

export const PreviewGenerationError = ({ onRetry }: PreviewGenerationErrorProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles['generation-error']} data-testid="preview-generation-error" role="alert">
      <CUIText variant="h2" className={styles['generation-error-title']}>
        {t('previewView.generationError.title')}
      </CUIText>
      <CUIText as="p" className={styles['generation-error-description']}>
        {t('previewView.generationError.description')}
      </CUIText>
      <Button variant="primary" onClick={onRetry} testId="preview-generation-retry-button">
        {t('previewView.generationError.retryButton')}
      </Button>
    </div>
  );
};
